import { lazy } from 'react';
import { roles } from 'common/constants/options';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';

const PqrsAdminPage = lazy(() => import('components/pqrs/PqrsAdminPage'));
const ClientPqrsPage = lazy(() => import('components/pqrs/ClientPqrsPage'));

const pqrsRoutes = [
  {
    key: 'admin-pqrs',
    exact: true,
    path: routes.adminPqrs.path,
    component: PqrsAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'my-pqrs',
    exact: true,
    path: routes.myPqrs.path,
    component: ClientPqrsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.client, roles.trainer]
  }
];

export default pqrsRoutes;
